import React, { useState } from "react";
import { Search, Moon, Zap, ChevronDown, CloudUpload, Menu, X } from "lucide-react";
import "../lms.css";

export default function LmsTopbar({ onUploadClick, onMenuClick }) {
  const [searchVal, setSearchVal] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="lms-topbar">
      {/* Hamburger — mobile only */}
      <button
        className="lms-topbar-icon-btn lms-hamburger"
        onClick={onMenuClick}
        title="Toggle menu"
      >
        <Menu size={18} strokeWidth={2} />
      </button>

      {/* Search — hidden on mobile unless toggled */}
      <div className={`lms-topbar-search ${searchOpen ? "lms-topbar-search--open" : ""}`}>
        <span className="lms-topbar-search-icon">
          <Search size={15} strokeWidth={2} />
        </span>
        <input
          type="text"
          placeholder="Search courses, students, classes..."
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
        {/* Close search on mobile */}
        {searchOpen && (
          <button
            className="lms-topbar-search-close"
            onClick={() => setSearchOpen(false)}
          >
            <X size={14} strokeWidth={2} />
          </button>
        )}
      </div>

      {/* Right side */}
      <div className="lms-topbar-right">
        {/* Mobile search toggle */}
        <button
          className="lms-topbar-icon-btn lms-search-toggle"
          onClick={() => setSearchOpen((o) => !o)}
          title="Search"
        >
          <Search size={16} strokeWidth={2} />
        </button>

        {/* Dark mode toggle */}
        <button className="lms-topbar-icon-btn" title="Toggle dark mode">
          <Moon size={16} strokeWidth={2} />
        </button>

        {/* Upload Course Material — label hidden on small screens */}
        {/* <button
          className="lms-btn-primary lms-btn-topbar"
          onClick={onUploadClick}
        >
          <CloudUpload size={15} strokeWidth={2} />
          <span className="lms-btn-label">Upload Material</span>
        </button> */}

        {/* Quick Action — hidden on mobile */}
        {/* <button className="lms-btn-primary lms-btn-topbar lms-btn-quick">
          <Zap size={15} strokeWidth={2} />
          <span className="lms-btn-label">Quick Action</span>
          <ChevronDown size={13} strokeWidth={2} />
        </button> */}
      </div>
    </header>
  );
}
